import React from "react";
import { noop } from "lodash";

import { Component } from "../../../../commons/types/component";
import cn from "../../libs/class-name";

export type ClickHandler<V> = (value: V) => void;

interface Props<V> extends Component {
  value: V;
  label: React.ReactNode;
  selected?: boolean;
  onClick?: ClickHandler<V>;
}

function SelectMenuItem<V>({ classNames = [], value, label = null, selected = false, onClick = noop }: Props<V>) {
  const handleClick: React.EventHandler<React.MouseEvent<HTMLButtonElement>> = event => {
    event.preventDefault();
    if (onClick) {
      onClick(value);
    }
  };

  return (
    <button type="button" className={cn("SelectMenuItem", [{ selected }], classNames)} onClick={handleClick}>
      {label}
    </button>
  );
}

export default SelectMenuItem;
